module.exports = __webpack_public_path__ + "img/tomo.7b35ddd3.svg";